export default __webpack_public_path__ + "static/media/Atticus_Logo.9bf46382.svg";